import React, { useRef } from 'react';
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  CircularProgress,
  Button,
  IconButton,
  TablePagination,
  TextField,
  MenuItem,
  ListItemText,
  Snackbar,
  Alert,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
// import CustomDateModal from './CustomDateModal';
import moment from 'moment';
// import { listOutstandingInvoiceMaster, listOutstandingPurchaseMaster } from '../../graphql';
import { makeStyles } from '@mui/styles';
// import { useThemes } from '../Theme/theme';
// import { showWarningSnackbar } from '../snackBar/snakbar';
import { API, graphqlOperation } from 'aws-amplify';
// import { defaultRowsPerPageOptions } from '../../utils/common';
import { Add } from '@mui/icons-material';
import { listOutstandingInvoiceMaster, listOutstandingPurchaseMaster } from '../../graphql';
import { showWarningSnackbar } from '../snackBar/snakbar';
import CustomDateModal from '../modals/CustomDateModal';
import { defaultRowsPerPageOptions } from '../../utils/common';
import { useThemes } from '../Theme/theme';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
  table: {
    width: '100%',
    '& .MuiTableCell-root': {
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      minWidth: '40px',
    },
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  width: '100%',
  maxHeight: { xs: '70%', sm: '100%' },
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  /* Hide scrollbar for Firefox */
  scrollbarWidth: 'none',

  /* Hide scrollbar for IE, Edge */
  msOverflowStyle: 'none',
};

let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = '0' + dd;
if (mm < 10) mm = '0' + mm;

const todayDate = yy + '-' + mm + '-' + dd;
const NewPayableReceivableAgeing = ({ open, setOpen, reportType,tableName }) => {
  const format = (num) =>
    Number(num).toLocaleString('en', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const dashboardData = useSelector((state) => state?.DashboardDataReducer);

  const { startTimeStamp, endTimeStamp, range, basedOn } = dashboardData?.bsPeriod;
  const { theme } = useThemes();
  const fromDayRefs = useRef([]);
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);
  const [dateRange, setDateRange] = useState('today');
  const [invDueDateRange, setInvDueDateRage] = useState('invoiceDate');
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [customDateModal, setCustomDateModal] = useState(false);
  const [modalStartDate, setmodalStartDate] = useState('');
  const [modalEndDate, setmodalEndDate] = useState('');
  const [customDate, setCustomDate] = useState(todayDate);
  const [tableCell, setTableCell] = useState([]);
  const [fromToArr, setFromToArr] = useState([
    ...[
      { from: 0, to: 30 },
      { from: 31, to: 60 },
      { from: 61, to: 90 },
    ],
  ]);

  const [warningSnakbar, setWarningSnakbar] = useState(false);
  const [warningText, setWarningText] = useState('');
  const [filterData, setFilterData] = useState([]);
  const [totalAmt, setTotalAmt] = useState([]);
  const [rowTotalBalanceDue, setRowTotalBalanceDue] = useState([]);
  const [selectedCell, setSelectedCell] = useState('');
  const [maxDaysTotal, setMaxDaysTotal] = useState(0);
  const [ageingShedule, setAgeingShedule] = useState({
    sheduleFrom: '',
    sheduleTo: '',
  });
  const [addEvent, setAddEvent] = useState(false);
  const lastValidFromValues = useRef({});
  const lastValidToValues = useRef({});

  const [editRow, setEditRow] = useState(null);
  const [addCell, setAddCell] = useState(false);

  const isSelected = (name) => selected.indexOf(name) !== -1;

  function addAgeingShedule() {
    setSelectedCell('');
    let isValid = true;
    let wrgMsg = '';

    const newFrom = Number(ageingShedule.sheduleFrom);
    const newTo = Number(ageingShedule.sheduleTo);

    if (newFrom >= newTo) {
      isValid = false;
      wrgMsg = 'Schedule From should be less than Schedule To';
    }
    const allEmpty = tableCell.every(item => item.fromDay === "" && item.toDay === "");
    if(!allEmpty){
    tableCell.forEach((ele) => {
      const existingFrom = Number(ele?.fromDay);
      const existingTo = ele?.toDay === undefined || ele?.toDay === null ? 1000 : Number(ele.toDay);

      if (existingFrom === newFrom && existingTo === newTo) {
        isValid = false;
        wrgMsg = 'The selected period already exists';
        return;
      }

      if (existingFrom === newFrom) {
        isValid = false;
        wrgMsg = 'The Selected Schedule From range already exists';
        return;
      }
      if (existingTo === newTo) {
        isValid = false;
        wrgMsg = 'The Selected Schedule To range already exists';
        return;
      }

      const isOverlap =
        (newFrom >= existingFrom && newFrom <= existingTo) ||
        (newTo >= existingFrom && newTo <= existingTo) ||
        (existingFrom >= newFrom && existingTo <= newTo);

      if (isOverlap) {
        isValid = false;
        wrgMsg = 'The selected range overlaps with an existing period';
        return;
      }
    });
  }

    if (isValid) {
      setAddEvent(true);
      setAddCell(false);
      setFromToArr((prev) => [...prev, { from: ageingShedule.sheduleFrom, to: ageingShedule.sheduleTo }]);
      setAgeingShedule((prev) => ({
        ...prev,
        sheduleFrom: '',
        sheduleTo: '',
      }));
    } else {
      showWarningSnackbar(wrgMsg);
    }
  }
  async function getAgeingData(dateRange, customDate, value, rowfrom, limitno, open, mode, searchArr, reset) {
    try {
      let selectedDate;
      const rows = [];

      if (dateRange === 'today') {
        const today = new Date();
        today.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(today.getTime() / 1000); // UTC timestamp in seconds
      } else {
        const date = new Date(customDate);
        date.setUTCHours(0, 0, 0, 0);
        selectedDate = Math.floor(date.getTime() / 1000); // UTC timestamp in seconds
      }

      const query = reportType === 'ReceivableOutStanding' ? listOutstandingInvoiceMaster : listOutstandingPurchaseMaster;

      const resData = await API.graphql(
        graphqlOperation(query, {
          startdate: startTimeStamp,
          enddate: endTimeStamp,
          rowfrom: rowfrom,
          limitno: limitno,
          word: value,
          searchmode: mode,
          ordertype: 'DESC',
          columnname: 'enteredtimestamp', // Fixed typo: "enteredtimesstamp"
          searcharray: JSON.stringify(searchArr),
          ageing: range === 'date' ? 0 : 1,
          basedon: basedOn === 'invoiceDate' ? 1 : 0,
        })
      );

      const outstandingData =
        reportType === 'ReceivableOutStanding' ? resData?.data?.listOutstandingInvoiceMaster : resData?.data?.listOutstandingPurchaseMaster;

      outstandingData.forEach((data) => {
        let invoiceDateTS = 0;
        let dueDateTS = data?.duedate * 1000;

        if (reportType === 'ReceivableOutStanding') {
          invoiceDateTS = data?.invoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.invoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
        } else {
          invoiceDateTS = data?.purchaseinvoicedate * 1000;
          data.invoiceDate = moment(invoiceDateTS).format('DD-MMM-YYYY');
          data.dueDate = moment(dueDateTS).format('DD-MMM-YYYY');
          data.voucherNo = data?.purchaseinvoicenumber;
          data.dueDays = Math.abs(Number(data?.overduedays));
          data.totalCount = data?.recordcount;
        }

        const isDueDateMode = invDueDateRange === 'dueDate';
        const targetDate = isDueDateMode ? dueDateTS : invoiceDateTS;

        // if (targetDate <= selectedDate) {
        rows.push(data);
        // }
      });
      if (reset === true) {
        setRows(rows);
        setTableHead(rows);
      } else {
        setRows((prevData) => {
          const updatedData = [...prevData, ...rows];
          setTableHead(updatedData);
          return updatedData;
        });
      }

      // setRows(rows);
      // setTableHead(rows);
    } catch (error) {
      console.log('error', error);
    }
  }

  useEffect(() => {
    getAgeingData(dateRange, customDate, '', 0, rowsPerPage, true, 0, [], true);
  }, [addEvent, dateRange, invDueDateRange, customDate, selectedCell, open, endTimeStamp, startTimeStamp, basedOn, range,rowsPerPage]);

  function setTableHead(rows) {
    
    
    const [selFrom, , selTo] = selectedCell.split(' '); // "61", "-", "90"
    // const maxToDay = Math.max(...fromToArr.map((ele) => Number(ele.to)));
    const filteredArr = fromToArr.filter((ele) => !(Number(ele.from) === Number(selFrom) && Number(ele.to) === Number(selTo)));

    const maxToDay =filteredArr.length===0?0: Math.max(...filteredArr.map((ele) => Number(ele.to)));

    setAddEvent(false);

    let serialNoArr = [
      {
        id: 'SL.No',
        label: 'SL.No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displyNameArr = [
      {
        id: 'PartyName',
        label: reportType === 'ReceivableOutStanding' ? 'Customer Name' : 'Supplier Name',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceNoArr = [
      {
        id: 'VoucherNo',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice No' : 'Voucher No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceDateArr = [
      {
        id: 'VoucherDate',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice Date' : 'Purchase Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayDueDateArr = [
      {
        id: 'Due Date',
        label: 'Due Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totArr = [
      {
        id: 'Total',
        label: 'Total',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let maxDaysArr = [
      {
        id: 'maxToDay',
        label: maxToDay + '+' + ' ' + 'Days',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let daysArr = [];
    fromToArr.map((ele) => {
      daysArr.push({
        id: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        label: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        minWidth: '80px',
        fromDay: ele.from,
        toDay: ele.to,
        diffday: Number(ele.to) - Number(ele.from),
        icon: true,
      });
    });
    let totBalanceDueAmount = 0;
    let totRowAmount = 0;
    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
    if (selectedCell !== '') {
      daysArr = daysArr.filter((ele) => {
        if (ele.label !== selectedCell) {
          return ele;
        }
      });
      daysArr = [...daysArr]?.sort((a, b) => a.toDay - b.toDay);
      let filterRowTotalBalanceDue = rowTotalBalanceDue.filter((ele) => {
        if (ele.period !== selectedCell) {
          return ele;
        }
      });
      let cellSelected = selectedCell.split(' ');
      let filterArr = fromToArr.filter((ele) => {
        if (ele.from !== Number(cellSelected[0]) && ele.to !== cellSelected[2]) {
          return ele;
        }
      });
      setFromToArr(filterArr);
    }
    rows.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });
    const uniqueIds = [];
    let tempArray = [];
    const unique = arrOfBalancDue.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.label);
      if (!isDuplicate) {
        uniqueIds.push(element.label);
        tempArray.push({
          period: element.label,
          balanceDueAmt: element.amount,
        });
        return true;
      } else {
        tempArray.map((item) => {
          if (element.label === item.period) {
            item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
          }
        });
      }
      return false;
    });
    setRowTotalBalanceDue(tempArray);
    let newRows = [];

    rows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    let maxDaysTotal = 0;
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });
    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });
    maxDaysTotal = tempArrayArr.reduce((sum, item) => sum + item.maxDaysBalanceAmt, 0);
    setMaxDaysTotal(maxDaysTotal);

    setTotalAmt(totBalanceDueAmount);
    setFilterData(tempArrayArr);
    let combinedArr = [
      ...serialNoArr,
      ...displyNameArr,
      ...displayInvoiceNoArr,
      ...displayInvoiceDateArr,
      ...displayDueDateArr,
      ...daysArr,
      ...maxDaysArr,
      ...totArr,
    ];
    setTableCell(combinedArr);
  }

  const handleRangeChange = (from, to, index) => {
    let updatedTableArr = [...tableCell];
    let updatedFromToArr = [...fromToArr];
    let updatedFilterData = [...filterData];
    let updatedRows = [...rows];
    let maxToDay = Math.max(...updatedFromToArr.map((ele) => Number(ele.to)));
    let serialNoArr = [
      {
        id: 'SL.No',
        label: 'SL.No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displyNameArr = [
      {
        id: 'PartyName',
        label: reportType === 'ReceivableOutStanding' ? 'Customer Name' : 'Supplier Name',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceNoArr = [
      {
        id: 'VoucherNo',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice No' : 'Voucher No',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayInvoiceDateArr = [
      {
        id: 'VoucherDate',
        label: reportType === 'ReceivableOutStanding' ? 'Invoice Date' : 'Purchase Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let displayDueDateArr = [
      {
        id: 'Due Date',
        label: 'Due Date',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totArr = [
      {
        id: 'Total',
        label: 'Total',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];

    let newFromDay = from === '' ? 0 : Number(from);
    let newToDay = to === '' ? 0 : Number(to);

    if (newFromDay >= newToDay) {
      // setWarningSnakbar(true);
      showWarningSnackbar('From Day must be earlier than  To day');
      return;
    }
    const isDuplicate = updatedFromToArr.some((range) => range.from === newFromDay && range.to === newToDay);

    if (isDuplicate) {
      // setWarningSnakbar(true);
      showWarningSnackbar('This range already exists');
      return;
    }

    updatedTableArr[index] = {
      ...updatedTableArr[index],
      fromDay: newFromDay,
      toDay: newToDay,
      id: `${newFromDay} - ${newToDay} Days`,
      label: `${newFromDay} - ${newToDay} Days`,
      diffday: newToDay - newFromDay,
    };
    for (let i = index + 1; i < updatedTableArr.length; i++) {
      let prevToDay = updatedTableArr[i - 1]?.toDay || 0;
      let newFrom = prevToDay + 1;
      let newTo = newFrom + 29;

      updatedTableArr[i] = {
        ...updatedTableArr[i],
        fromDay: newFrom,
        toDay: newTo,
        id: `${newFrom} - ${newTo} Days`,
        label: `${newFrom} - ${newTo} Days`,
        diffday: newTo - newFrom,
      };

      if (i - 5 >= 0 && updatedFromToArr[i - 5]) {
        updatedFromToArr[i - 5] = {
          ...updatedFromToArr[i - 5],
          from: newFrom,
          to: newTo,
        };
      }
    }

    updatedFromToArr[index - 5] = {
      ...updatedFromToArr[index - 5],
      from: newFromDay,
      to: newToDay,
    };

    let daysArr = [];
    updatedFromToArr?.map((ele) => {
      daysArr.push({
        id: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        label: ele.from + ' ' + '-' + ' ' + ele.to + ' ' + 'Days',
        minWidth: '80px',
        fromDay: ele.from,
        toDay: ele.to,
        diffday: Number(ele.to) - Number(ele.from),
        icon: true,
      });
    });
    maxToDay = Math.max(...updatedFromToArr.map((ele) => Number(ele.to)));
    let maxDaysArr = [
      {
        id: 'maxToDay',
        label: maxToDay + '+' + ' ' + 'Days',
        minWidth: 80,
        fromDay: '',
        toDay: '',
        icon: false,
      },
    ];
    let totBalanceDueAmount = 0;
    let totRowAmount = 0;
    let startNo = 0;
    let endNo = 0;
    let arrOfBalancDue = [];
    updatedRows?.map((col) => {
      col.amtArr = [];
      col.newAmtArr = [];
      daysArr?.map((ele) => {
        col.amtArr.push({
          label: ele.fromDay + ' ' + '-' + ' ' + ele.toDay + ' ' + 'Days',
          amount: col.dueDays >= ele.fromDay && col.dueDays <= ele.toDay ? Number(col?.balancedueamount).toFixed(2) : 0,
        });

        startNo = ele.fromDay;
        endNo = ele.toDay;
        if (col.dueDays >= startNo && col.dueDays <= endNo) {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: col.balancedueamount,
          });
        } else {
          arrOfBalancDue.push({
            label: startNo + ' ' + '-' + ' ' + endNo + ' ' + 'Days',
            amount: 0,
          });
        }
      });
      col.amtArr.map((ele) => {
        totBalanceDueAmount += Number(ele.amount);
      });
    });
    const uniqueIds = [];
    let tempArray = [];
    const unique = arrOfBalancDue.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.label);
      if (!isDuplicate) {
        uniqueIds.push(element.label);
        tempArray.push({
          period: element.label,
          balanceDueAmt: element.amount,
        });
        return true;
      } else {
        tempArray.map((item) => {
          if (element.label === item.period) {
            item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
          }
        });
      }
      return false;
    });
    setRowTotalBalanceDue(tempArray);
    let newRows = [];
    rows.map((ele) => {
      newRows.push({
        PartyName: ele?.partylegalname,
        InvoiceNumber: ele?.voucherNo,
        InvoiceDate: ele?.invoiceDate,
        DueDate: ele?.dueDate,
        arr: ele.amtArr,
        maxDaysBalanceAmt: ele?.dueDays > maxToDay ? Number(ele?.balancedueamount) : 0,
        totalCount: ele?.totalCount,
      });
    });

    const uniqueIdsArr = [];
    let tempArrayArr = [];
    const uniqueArr = newRows.filter((element) => {
      const isDuplicateArr = uniqueIdsArr.includes(element.InvoiceNumber);
      if (!isDuplicateArr) {
        uniqueIdsArr.push(element.InvoiceNumber);
        tempArrayArr.push({
          PartyName: element.PartyName,
          InvoiceNumber: element.InvoiceNumber,
          InvoiceDate: element?.InvoiceDate,
          DueDate: element?.DueDate,
          arr: element.arr,
          maxDaysBalanceAmt: element?.maxDaysBalanceAmt,
          totalCount: element?.totalCount,
        });
        return true;
      } else {
        tempArrayArr.map((item) => {
          if (element.InvoiceNumber === item.InvoiceNumber) {
            item.arr = [...item.arr, ...element.arr];
          }
        });
      }
      return false;
    });

    tempArrayArr.map((ele) => {
      const uniqueIds = [];
      let tempArray = [];
      const unique = ele.arr.filter((element) => {
        const isDuplicate = uniqueIds.includes(element.label);
        if (!isDuplicate) {
          uniqueIds.push(element.label);
          tempArray.push({
            period: element.label,
            balanceDueAmt: element.amount,
          });
          return true;
        } else {
          tempArray.map((item) => {
            if (element.label === item.period) {
              item.balanceDueAmt = Number(element.amount) + Number(item.balanceDueAmt);
            }
          });
        }
        return false;
      });
      ele.arr = tempArray;
    });
    let maxDaysTotal = 0;
    maxDaysTotal = tempArrayArr.reduce((sum, item) => sum + item.maxDaysBalanceAmt, 0);
    setMaxDaysTotal(maxDaysTotal);

    setTotalAmt(totBalanceDueAmount);
    setTotalAmt(totBalanceDueAmount);
    setFilterData(tempArrayArr);

    let combinedArr = [
      ...serialNoArr,
      ...displyNameArr,
      ...displayInvoiceNoArr,
      ...displayInvoiceDateArr,
      ...displayDueDateArr,
      ...daysArr,
      ...maxDaysArr,
      ...totArr,
    ];
   
    setFromToArr(updatedFromToArr);
    setTableCell(combinedArr);
  };
  // useEffect(() => {
  //   if (fromToArr.length === 0) {
  //     setTableCell([]);
  //   }
  // }, [fromToArr]);
  return (
    <Box
      sx={{
        marginTop: { xs: '20px', sm: '0px' },
      }}
    >
      
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '100%',
              overflow: 'hidden',
           
            }}
          >
           <Box sx={{ display: "flex", justifyContent: "space-between" ,m:1}}>
            <Typography sx={{ fontWeight: 600, fontSize: { xs: '11px', sm: '16px' } }}>
                          {tableName}
                        </Typography>
  <Button
    variant="contained"
    endIcon={<Add />}
    size="small" // reduces height
    sx={{ minHeight: "32px", padding: "4px 12px" }} // fine-tune height
    onClick={()=>setAddCell(true)}
  >
    Add New Age
  </Button>
</Box>
            {/* {fromToArr.length > 0 && ( */}
              <>
                <TableContainer
                  sx={{
                    m: 1,
                    '::-webkit-scrollbar': {
                      width: 14,
                    },
                    '::-webkit-scrollbar-track': {
                      // background: "#f1f1f1",
                    },
                    '::-webkit-scrollbar-thumb': {
                      background: 'primary.main',
                    },
                    maxHeight: 500,
                  }}
                >
                  <Table stickyHeader sx={{ minWidth: '1500px', tableLayout: 'auto' }} className={classes.table} aria-label="sticky table">
                    <TableHead sx={{ color: theme.palette.secondary.main }}>
                      <TableRow className="EnabeleTableCellBorder">
                        {tableCell.map((column, ind) => {
                          return column?.icon === true ? (
                            <TableCell
                              key={ind}
                              sx={{
                                // width: "210px",
                                whiteSpace: 'nowrap',
                                minWidth: '150px', // Adjust as needed
                                width: '100%',
                                backgroundColor: `#E6CED7 !important`,
                                color: '#FFF',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  backgroundColor: `#E6CED7 !important`,
                                  // maxWidth: "240px",
                                  whiteSpace: 'nowrap',
                                  width: 'auto',
                                }}
                              >
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: `#E6CED7 !important`,
                                    gap: '1px',
                                  }}
                                  onClick={() => setEditRow(ind)} // Set editRow on click
                                >
                                  <TextField
                                    type="text"
                                    size="small"
                                    value={column?.fromDay || 0}
                                    autoFocus={editRow === ind}
                                    inputRef={(el) => (fromDayRefs.current[ind] = el)}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const numericValue = Number(value);

                                      if (numericValue > 1200) {
                                        showWarningSnackbar('Date range exceeds the allowed limit');
                                        return;
                                      }

                                      const updatedTableArr = [...tableCell];
                                      updatedTableArr[ind] = {
                                        ...updatedTableArr[ind],
                                        fromDay: value,
                                      };
                                      setTableCell(updatedTableArr);
                                    }}
                                    onFocus={() => {
                                      // Save current valid value for revert if needed
                                      lastValidFromValues.current[ind] = Number(column?.fromDay || 0);
                                    }}
                                    onBlur={() => {
                                      const currentFrom = Number(column?.fromDay || 0);
                                      const lastValid = Number(lastValidFromValues.current[ind] || 0);

                                      // ✅ Skip validation if no change
                                      if (currentFrom === lastValid) {
                                        setEditRow(null);
                                        return;
                                      }

                                      const currentTo = Number(column?.toDay || 0);

                                      // Step 1: Basic range validation
                                      if (currentFrom >= currentTo) {
                                        showWarningSnackbar('From Day must be earlier than  To day');

                                        const updatedTableArr = [...tableCell];
                                        updatedTableArr[ind].fromDay = lastValid;
                                        setTableCell(updatedTableArr);
                                        setEditRow(null);
                                        return;
                                      }

                                      // Step 2: Duplicate/Overlap validation
                                      let warningText = '';
                                      const isInvalidRange = fromToArr.some((range, idx) => {
                                        if (idx === ind - 5) return false; // Don't compare with itself

                                        const existingFrom = Number(range.from);
                                        const existingTo = Number(range.to);

                                        if (existingFrom === currentFrom && existingTo === currentTo) {
                                          warningText = 'This range already exists';
                                          return true;
                                        }

                                        if (existingFrom === currentFrom) {
                                          warningText = "The selected 'From' day already exists";
                                          return true;
                                        }

                                        if (existingTo === currentTo) {
                                          warningText = "The selected 'To' day already exists";
                                          return true;
                                        }

                                        // const overlaps =
                                        //   (currentFrom >= existingFrom && currentFrom <= existingTo) ||
                                        //   (currentTo >= existingFrom && currentTo <= existingTo) ||
                                        //   (existingFrom >= currentFrom && existingTo <= currentTo);
                                        const overlaps = currentFrom <= existingFrom || currentFrom >= existingTo;

                                        if (!overlaps) {
                                          warningText = 'The selected range overlaps with an existing period';
                                          return true;
                                        }

                                        return false;
                                      });

                                      if (isInvalidRange) {
                                        showWarningSnackbar(warningText);

                                        const updatedTableArr = [...tableCell];
                                        updatedTableArr[ind].fromDay = lastValid;
                                        setTableCell(updatedTableArr);
                                        setEditRow(null);
                                        return;
                                      }

                                      // Step 3: Passed all checks
                                      handleRangeChange(currentFrom, currentTo, ind);
                                      setEditRow(null);
                                    }}
                                    sx={{
                                      minWidth: '50px',
                                      width: 'auto',
                                      maxWidth: '120px',
                                      textAlign: 'center',
                                      '& .MuiInputBase-input': {
                                        textAlign: 'center',
                                        // color: '#FFF',
                                      },
                                      '& fieldset': {
                                        border: editRow === ind ? '1px solid white !important' : 'none',
                                      },
                                    }}
                                    inputProps={{
                                      style: {
                                        width: `${(column?.fromDay?.toString().length || 1) * 8}px`,
                                      },
                                    }}
                                  />

                                  <Box
                                    sx={{
                                      mx: '1px',
                                      //  color: '#FFF'
                                    }}
                                  >
                                    {' '}
                                    -{' '}
                                  </Box>

                                  <TextField
                                    type="text"
                                    size="small"
                                    value={column?.toDay || 0}
                                    autoFocus={editRow === ind}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      const numericValue = Number(value);

                                      if (numericValue > 1200) {
                                        showWarningSnackbar('Date range exceeds the allowed limit');
                                        return;
                                      }

                                      const updatedTableArr = [...tableCell];
                                      updatedTableArr[ind] = {
                                        ...updatedTableArr[ind],
                                        toDay: value,
                                      };
                                      setTableCell(updatedTableArr);
                                    }}
                                    onFocus={() => {
                                      lastValidToValues.current[ind] = Number(column?.toDay || 0);
                                    }}
                                    onBlur={() => {
                                      const currentFrom = Number(column?.fromDay || 0);
                                      const currentTo = Number(column?.toDay || 0);
                                      const lastValid = Number(lastValidToValues.current[ind] || 0);

                                      // ✅ Skip validation if no change
                                      if (currentTo === lastValid) {
                                        setEditRow(null);
                                        return;
                                      }

                                      let warningText = '';

                                      // Step 1: Basic validation
                                      if (currentFrom >= currentTo) {
                                        showWarningSnackbar('From Day must be earlier than  To day');

                                        const updatedTableArr = [...tableCell];
                                        updatedTableArr[ind].toDay = lastValid;
                                        setTableCell(updatedTableArr);
                                        setEditRow(null);
                                        return;
                                      }

                                      // Step 2: Duplicate / Overlap validation
                                      const isInvalidRange = fromToArr.some((range, idx) => {
                                        if (idx === ind - 5) return false;

                                        const existingFrom = Number(range.from);
                                        const existingTo = Number(range.to);

                                        if (existingFrom === currentFrom && existingTo === currentTo) {
                                          warningText = 'This range already exists';
                                          return true;
                                        }

                                        if (existingFrom === currentFrom) {
                                          warningText = "The selected 'From' day already exists";
                                          return true;
                                        }

                                        if (existingTo === currentTo) {
                                          warningText = "The selected 'To' day already exists";
                                          return true;
                                        }

                                        // const overlaps =
                                        //   (currentFrom >= existingFrom && currentFrom <= existingTo) ||
                                        //   (currentTo >= existingFrom && currentTo <= existingTo) ||
                                        //   (existingFrom >= currentFrom && existingTo <= currentTo);

                                        const overlaps = currentTo >= existingFrom || currentTo <= existingTo;

                                        if (!overlaps) {
                                          warningText = 'The selected range overlaps with an existing period';
                                          return true;
                                        }

                                        return false;
                                      });

                                      if (isInvalidRange) {
                                        showWarningSnackbar(warningText);

                                        const updatedTableArr = [...tableCell];
                                        updatedTableArr[ind].toDay = lastValid;
                                        setTableCell(updatedTableArr);
                                        setEditRow(null);
                                        return;
                                      }

                                      // Step 3: Passed validation
                                      handleRangeChange(currentFrom, currentTo, ind);
                                      setEditRow(null);
                                    }}
                                    sx={{
                                      minWidth: '50px',
                                      width: 'auto',
                                      maxWidth: '120px',
                                      textAlign: 'center',
                                      '& .MuiInputBase-input': {
                                        textAlign: 'center',
                                        // color: '#FFF',
                                      },
                                      '& fieldset': {
                                        border: editRow === ind ? '1px solid white !important' : 'none',
                                      },
                                    }}
                                    inputProps={{
                                      style: {
                                        width: `${(column?.toDay?.toString().length || 1) * 8}px`,
                                      },
                                    }}
                                  />

                                  <Box
                                    sx={{
                                      ml: '1px',
                                      // color: '#FFF'
                                    }}
                                  >
                                    {' '}
                                    Days{' '}
                                  </Box>
                                </Box>

                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    ml: '5px',
                                  }}
                                >
                                  {/* Edit Icon */}
                                  <EditIcon
                                    onClick={() => {
                                      setEditRow(ind); // Set the row to edit mode
                                      if (fromDayRefs.current[ind]) {
                                        fromDayRefs.current[ind].focus();
                                      }
                                    }}
                                    sx={{
                                      fontSize: '13px',
                                      padding: '5px',
                                      cursor: 'pointer',
                                      // color: '#FFF',
                                    }}
                                  />
                                  {/* Close Icon */}
                                  <CloseIcon
                                    onClick={() => {
                                      setEditRow(null); // Exit edit mode
                                      setSelectedCell(column.label);
                                    }}
                                    sx={{
                                      fontSize: '15px',
                                      padding: '0px',
                                      cursor: 'pointer',
                                      // color: '#FFF',
                                    }}
                                  />
                                </Box>
                              </Box>
                            </TableCell>
                          ) : (
                            <TableCell
                              key={ind}
                              sx={{
                                textAlign: column?.id === 'Total' ? 'right' : 'left',
                                whiteSpace: 'nowrap',
                                minWidth: column?.id === 'SL.No' ? '50px' : '150px',
                                width: column?.id === 'SL.No' ? '50px' : '100%',
                                position: ['SL.No', 'PartyName', 'VoucherNo', 'VoucherDate', 'Due Date', 'Total', 'maxToDay'].includes(
                                  column?.id
                                )
                                  ? { xs: 'static', md: 'sticky' }
                                  : { xs: 'static', md: 'sticky' },
                                left:
                                  column?.id === 'SL.No'
                                    ? 0
                                    : column?.id === 'PartyName'
                                    ? '80px'
                                    : column?.id === 'VoucherNo'
                                    ? '230px'
                                    : column?.id === 'VoucherDate'
                                    ? '340px'
                                    : column?.id === 'Due Date'
                                    ? '460px'
                                    : undefined,
                                top: ['Total', 'maxToDay'].includes(column?.id) ? 0 : undefined,
                                backgroundColor: `#E6CED7 !important`,
                                // color: '#FFF !important',
                                zIndex: ['SL.No', 'PartyName', 'VoucherNo', 'VoucherDate', 'Due Date'].includes(column?.id) ? 1100 : 'auto',
                                borderLeft: `20px solid #E6CED7`,
                                borderRight: column?.id === 'Due Date' ? '3px solid #CCC' : `20px solid #E6CED7`,
                                p: 0,
                              }}
                            >
                              {column?.id === 'maxToDay' ? (
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'stretch',
                                    height: '100%',
                                    width: '100%',
                                  }}
                                >
                                  {addCell === true  && (
                                    // <Box
                                    //   sx={{
                                    //     flex: 1,
                                    //     display: 'flex',
                                    //     flexDirection: 'column',
                                    //     alignItems: 'center',
                                    //     justifyContent: 'center',
                                    //     px: 1.5,
                                    //     whiteSpace: 'nowrap',
                                    //     width: 'auto',
                                    //     gap: 0.5, // control spacing between lines here
                                    //   }}
                                    // >
                                    //   {['ADD', 'NEW AGE'].map((text) => (
                                    //     <Typography
                                    //       key={text}
                                    //       onClick={() => setAddCell(true)}
                                    //       variant="text"
                                    //       size="small"
                                    //       disableRipple
                                    //       disableFocusRipple
                                    //       sx={{
                                    //         minWidth: 0, // remove 64px default
                                    //         p: 0, // no padding
                                    //         lineHeight: 1.2, // sane line-height
                                    //         textTransform: 'none',
                                    //         // color: '#FFF',
                                    //         border: 'none',
                                    //       }}
                                    //     >
                                    //       {text}
                                    //     </Typography>
                                    //   ))}
                                    // </Box>
                                  
                                    <>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          // justifyContent: 'space-between',
                                          backgroundColor: `#E6CED7 !important`,
                                          maxWidth: '240px',
                                          whiteSpace: 'nowrap',
                                          width: 'auto',
                                          ml: 2,
                                         
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: `#E6CED7 !important`,
                                            gap: '1px',
                                            width: '100%',
                                          }} // Set editRow on click
                                        >
                                          <TextField
                                            type="text"
                                            size="small"
                                            value={ageingShedule.sheduleFrom}
                                            className="Input_Amount"
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (!/^\d*$/.test(value)) {
                                                return; // block invalid input
                                              }

                                              if (value > 1200) {
                                                setWarningSnakbar(true);
                                                setWarningText('Date range exceeds the allowed limit');
                                                return;
                                              }
                                              if (value !== '') {
                                                setAgeingShedule((prev) => ({
                                                  ...prev,
                                                  sheduleFrom: value,
                                                }));
                                              } else {
                                                setAgeingShedule((prev) => ({
                                                  ...prev,
                                                  sheduleFrom: value,
                                                }));
                                              }
                                            }}
                                            sx={{
                                              minWidth: '50px',
                                              width: 'auto',
                                              // maxWidth: '120px',
                                              textAlign: 'center',
                                              '& .MuiInputBase-input': {
                                                textAlign: 'center',
                                                // color: '#FFF',
                                              },
                                              '& fieldset': {
                                                border: '1px solid white !important',
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                minWidth: '4ch', // minimum width for 4 characters
                                                width: `${(column?.toDay?.toString().length || 1) * 6}px`, // expand per char
                                              },
                                            }}
                                          />

                                          <Box
                                            sx={{
                                              mx: '1px',
                                              //  color: '#FFF'
                                            }}
                                          >
                                            {' '}
                                            -{' '}
                                          </Box>

                                          <TextField
                                            type="text"
                                            size="small"
                                            value={ageingShedule.sheduleTo}
                                            className="Input_Amount"
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (!/^\d*$/.test(value)) {
                                                return; // block invalid input
                                              }

                                              if (value > 1200) {
                                                setWarningSnakbar(true);
                                                setWarningText('Date range exceeds the allowed limit');
                                                return;
                                              }
                                              if (value !== '') {
                                                setAgeingShedule((prev) => ({
                                                  ...prev,
                                                  sheduleTo: value,
                                                }));
                                              } else {
                                                setAgeingShedule((prev) => ({
                                                  ...prev,
                                                  sheduleTo: value,
                                                }));
                                              }
                                            }}
                                            sx={{
                                              minWidth: '50px',
                                              width: 'auto',
                                              // maxWidth: '120px',
                                              textAlign: 'center',
                                              '& .MuiInputBase-input': {
                                                textAlign: 'center',
                                                // color: '#FFF',
                                              },
                                              '& fieldset': {
                                                border: '1px solid white !important',
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                minWidth: '4ch', // minimum width for 4 characters
                                                width: `${(column?.toDay?.toString().length || 1) * 6}px`, // expand per char
                                              },
                                            }}
                                          />

                                          <Box
                                            sx={{
                                              ml: '2px',
                                              // color: '#FFF'
                                            }}
                                          >
                                            {' '}
                                            Days{' '}
                                          </Box>
                                        </Box>

                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            ml: '3px',
                                            mr: '4px',
                                          }}
                                        >
                                          {/* Edit Icon */}
                                          <Add
                                            onClick={addAgeingShedule}
                                            sx={{
                                              fontSize: '15px',
                                              padding: 0,
                                              cursor: 'pointer',
                                              // color: '#FFF',
                                              // stroke: '#FFF', // outline color
                                              // strokeWidth: 1, // thicker lines for "bold" effect
                                            }}
                                          />

                                          {/* Close Icon */}
                                          <CloseIcon
                                            onClick={() => {
                                              setAddCell(false);
                                              setAgeingShedule((prev) => ({
                                                ...prev,
                                                sheduleTo: '',
                                                sheduleFrom: '',
                                              }));
                                            }}
                                            sx={{
                                              fontSize: '15px',
                                              padding: 0,
                                              cursor: 'pointer',
                                              // color: '#FFF',
                                              // stroke: '#FFF', // outline color
                                              // strokeWidth: 1, // thicker lines for "bold" effect
                                            }}
                                          />
                                        </Box>
                                      </Box>
                                    </>
                                  )}
                                    <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{ borderRightWidth: 1, borderColor: '#d9d9d9', opacity: 1, height: '65px' }}
                                  />
                                  <Box sx={{ flex: addCell === true ? 3 : 1, display: 'flex', alignItems: 'center', px: 1.5 }}>
                                    <Typography sx={{ fontWeight: 'bold' }}>{column.label}</Typography>
                                  </Box>

                                
                                  
                                </Box>
                              ) : (
                                <Typography sx={{ fontWeight: 'bold', px: 1.5 }}>{column.label}</Typography>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    </TableHead>
                    {filterData.length > 0 ? (
                      <TableBody>
                        {filterData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((col, ind) => {
                          let totBalanceDueAmount = 0;

                          const isItemSelected = isSelected(page * rowsPerPage + (ind + 1));
                          const labelId = `enhanced-table-checkbox-${ind}`;

                          col?.arr.map((ele) => {
                            totBalanceDueAmount += Number(ele?.balanceDueAmt);
                          });
                          totBalanceDueAmount = Number(totBalanceDueAmount) + Number(col?.maxDaysBalanceAmt);

                          return (
                            <TableRow key={page * rowsPerPage + (ind + 1)}>
                              <TableCell
                                sx={{
                                  maxWidth: '40px',
                                  position: { xs: 'static', md: 'sticky' },
                                  left: 0,
                                  // zIndex:1100,
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                              >
                                {page * rowsPerPage + (ind + 1)}
                              </TableCell>
                              <TableCell
                                sx={{
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px', // Adjust as needed
                                  width: '100%',
                                  position: { xs: 'static', md: 'sticky' },
                                  left: '80px',
                                  // zIndex:1100,
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                              >
                                {col?.PartyName}
                              </TableCell>
                              <TableCell
                                sx={{
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px', // Adjust as needed
                                  width: '100%',
                                  position: { xs: 'static', md: 'sticky' },
                                  left: '230px',
                                  // zIndex:1100,
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                              >
                                {col?.InvoiceNumber}
                              </TableCell>
                              <TableCell
                                sx={{
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px', // Adjust as needed
                                  width: '100%',
                                  position: { xs: 'static', md: 'sticky' },
                                  left: '340px',
                                  // zIndex:1100,
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                              >
                                {col?.InvoiceDate}
                              </TableCell>
                              <TableCell
                                sx={{
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px', // Adjust as needed
                                  width: '100%',
                                  position: { xs: 'static', md: 'sticky' },
                                  left: '460px',
                                  // zIndex:1100,
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                  borderRight: '3px solid #CCC',
                                }}
                              >
                                {col?.DueDate}
                              </TableCell>

                              {col.arr.map((ele) => {
                                return (
                                  <TableCell
                                    sx={{
                                      maxWidth: '140px',
                                      backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                    }}
                                    align="right"
                                  >
                                    ₹ {ele?.balanceDueAmt == 0 ? '0.00' : format(Number(ele?.balanceDueAmt))}
                                  </TableCell>
                                );
                              })}
                              <TableCell
                                sx={{
                                  minWidth: '120px',
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                                align="right"
                              >
                                ₹ {col?.maxDaysBalanceAmt == 0 ? '0.00' : format(Number(col?.maxDaysBalanceAmt))}
                              </TableCell>
                              <TableCell
                                sx={{
                                  minWidth: '120px',
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                                align="right"
                              >
                                ₹{totBalanceDueAmount == 0 ? '0.00' : format(Number(totBalanceDueAmount))}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                        <TableRow>
                          <TableCell
                            sx={{
                              maxWidth: '40px',
                              fontWeight: 'bold',
                              position: { xs: 'static', md: 'sticky' },
                              left: 0,
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              zIndex: 1100,
                            }}
                          >
                            Total
                          </TableCell>
                          <TableCell
                            sx={{
                              position: { xs: 'static', md: 'sticky' },
                              left: '80px',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              zIndex: 1100,
                            }}
                          ></TableCell>
                          <TableCell
                            sx={{
                              position: { xs: 'static', md: 'sticky' },
                              left: '230px',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              zIndex: 1100,
                            }}
                          ></TableCell>
                          <TableCell
                            sx={{
                              position: { xs: 'static', md: 'sticky' },
                              left: '340px',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              zIndex: 1100,
                            }}
                          ></TableCell>
                          <TableCell
                            sx={{
                              position: { xs: 'static', md: 'sticky' },
                              left: '460px',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                              borderRight: '3px solid #CCC', // Ensure the row does not overlap with content
                              zIndex: 1100,
                            }}
                          ></TableCell>

                          {rowTotalBalanceDue.map((ele) => {
                            return (
                              <TableCell
                                sx={{
                                  whiteSpace: 'nowrap',
                                  minWidth: '150px', // Adjust as needed
                                  width: '100%',
                                  fontWeight: 'bold',
                                  backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                                  color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                                }}
                                align="right"
                              >
                                ₹ {ele?.balanceDueAmt == 0 ? '0.00' : format(Number(ele?.balanceDueAmt))}
                              </TableCell>
                            );
                          })}
                          <TableCell
                            align="right"
                            sx={{
                              whiteSpace: 'nowrap',
                              minWidth: '150px', // Adjust as needed
                              width: '100%',
                              fontWeight: 'bold',
                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            ₹ {maxDaysTotal == 0 ? '0.00' : format(Number(maxDaysTotal))}
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              whiteSpace: 'nowrap',
                              minWidth: '150px', // Adjust as needed
                              width: '100%',
                              fontWeight: 'bold',

                              backgroundColor: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : 'white',
                              color: theme?.palette?.TmId.id.toString().includes('9') ? 'white' : 'black',
                            }}
                          >
                            ₹ {totalAmt + maxDaysTotal == 0 ? '0.00' : format(Number(totalAmt + maxDaysTotal))}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell
                            colSpan={tableCell?.length}
                            align="center"
                            sx={{
                              color: '#818694',
                              fontFamily: 'overpass',
                              fontSize: 15,
                              fontWeight: 'bold',
                            }}
                          >
                            NO DATA FOUND
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>

                {/* <TablePagination
                sx={{
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    // width: '0.4em',
                    height: "0.2em",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: `${theme.palette.primary.main}47`,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "primary.main",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    background: `${theme.palette.primary.main}47`,
                  },
                }}
                rowsPerPageOptions={[5, 10, 20, 50]}
                component="div"
                count={filterData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              /> */}
                {filterData.length > 0 && (
                  <TablePagination
                    rowsPerPageOptions={defaultRowsPerPageOptions}
                    component="div"
                    count={filterData?.[0]?.totalCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => {
                      if (newPage > page) {
                        if (filterData?.length !== filterData?.[0]?.totalCount)
                          if (filterData.length < rowsPerPage * (newPage + 1)) {
                            getAgeingData(
                              dateRange,
                              customDate,
                              '',
                              filterData?.length,
                              Math.abs(rowsPerPage * (newPage + 1) - filterData.length),
                              true,
                              1
                            );
                          }
                      }
                      setPage(newPage);
                    }}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                )}
              </>
            {/* )} */}

            <CustomDateModal
              open={customDateModal}
              setOpen={setCustomDateModal}
              setmodalStartDate={setmodalStartDate}
              setmodalEndDate={setmodalEndDate}
              modalEndDate={modalEndDate}
              modalStartDate={modalStartDate}
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={warningSnakbar}
              autoHideDuration={6000}
              onClose={() => setWarningSnakbar(false)}
            >
              <Alert onClose={() => setWarningSnakbar(false)} variant="filled" severity="warning" sx={{ width: '100%' }}>
                {warningText}
              </Alert>
            </Snackbar>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
        </Box>
    </Box>
  );
};

export default NewPayableReceivableAgeing;
//.....New Changes
